import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router';

import { getS3Object } from '../utils/myKadImg';
import { authenticateCurrentUser } from '../redux/authenticate/actions';
import { getSingleCheck } from '../redux/singleCheck/actions';
import * as selectors from '../redux/selectors';
import * as singleCheckStatus from '../redux/singleCheck/status';
import { flashMessage } from '../redux/flash/actions';
import { sendReportEmail } from '../redux/email/actions';
import * as emailStatus from '../redux/email/status';

import Date from '../components/Date';
import Image from '../components/Image';
import Value from '../components/Value';
import Status from '../components/Status';
import Identity from '../components/Identity';
import Modal from '../components/Modal';

import refresh from '../assets/icons/ico_refresh.png';

import './SingleCheck.css';

class SingleCheck extends Component {
  static mapStateToProps = state => ({
    singleCheck: selectors.getSingleCheck(state),
  })

  static contextTypes = {
    store: PropTypes.object,
  }

  constructor(props) {
    super(props);
    this.state = {
      images: [],
      userID: '',
      checkID: '',
      singleCheck: props.singleCheck,
      showModal: false,
    }
  }

  async componentDidMount() {
    await this.start();
    await this.loadImages();
    this.getSingleCheck();
  }

  componentWillUnmount() {
    this.loadImages();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.singleCheck !== this.props.singleCheck) {
      this.setState({ singleCheck: nextProps.singleCheck });
    }
    if (this.props.singleCheck ||
      this.props.singleCheck.icFront !== nextProps.singleCheck.icFront ||
      this.props.singleCheck.icBack !== nextProps.singleCheck.icBack
    ) {
      this.loadImages();
    }
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  async start() {
    const { match } = this.props;
    await this.setStateAsync({ 
      checkID: this.getCheckId(match.params.id),
      userID: this.getUserId(match.params.id),
    });
  }

  async loadImages() {
    await this.setStateAsync({ loadingImages: true });
    const { store } = this.context;
    const { singleCheck } = this.props;
    const token = await store.dispatch(authenticateCurrentUser());
    let images;
    try {
      const runImages = [];
      if (singleCheck && singleCheck.icFront) {
        runImages.push(getS3Object(singleCheck.icFront, 'icFront', token));
      }
      if (singleCheck && singleCheck.icBack) {
        runImages.push(getS3Object(singleCheck.icBack, 'icBack', token));
      }
      images = await Promise.all(runImages);
    } catch (e) {
      return;
    }
    await this.setStateAsync({
      images,
      loadingImages: false,
    });
  }

  getCheckId = (str) => {
    return str.substring(
      str.indexOf('=') + 1,
      str.indexOf('&')
    );
  }
  getUserId = (str) => {
      return str.split('&uid=')[1];
    }

  getSingleCheck = async () => {
    const { store } = this.context;
    const body = {
      userID: this.state.userID,
      checkID: this.state.checkID,
    };
    const res = await store.dispatch(getSingleCheck(body));
    if (res > singleCheckStatus.SINGLECHECK_STATUS_OK) {
      store.dispatch(flashMessage('Fail to get single check', 'error'));
      store.dispatch(replace('/unique-users'));
      return;
    }
  }

  async ReportEmail(checks) {
    this.setState({ showModal: false });
    const { store } = this.context;
    const body = {
      userID: checks.userID,
      checkID: checks.checkID,
      profileID: checks.profileID,
    };
    const res = await store.dispatch(sendReportEmail(body));
    if (res === emailStatus.EMAIL_STATUS_OK) {
      store.dispatch(flashMessage(`Send email to ${checks.email} success`, 'notify'));
      return;
    }
    store.dispatch(flashMessage(`Fail to send email to ${checks.email}`, 'error'));
  }

  handleOpenModal = (obj) => {
    this.setState({
      showModal: this.state.showModal === obj.checkID ? null : obj.checkID,
    });
  }

  handleCloseModal = (event) => {
    event.preventDefault();
    this.setState({ showModal: false });
  }

  handleRefresh = async () => {
    const { store } = this.context;
    const body = {
      userID: this.state.userID,
      checkID: this.state.checkID,
    };
    const res = await store.dispatch(getSingleCheck(body));
    if (res > singleCheckStatus.SINGLECHECK_STATUS_OK) {
      store.dispatch(flashMessage('Fail to refresh', 'error'));
      return;
    }
    store.dispatch(flashMessage('Refresh success', 'notify'));
  }

  render() {
    const { singleCheck } = this.props;
    const uploadedICFront = this.state.images.find(i => i.name === 'icFront');
    const uploadedICBack = this.state.images.find(i => i.name === 'icBack');
    return (
      <div className="singleCheck">
        <Modal
          close={this.state.showModal === singleCheck.checkID}
          onClickNo={this.handleCloseModal}
          onClickYes={() => this.ReportEmail(singleCheck)}
        >
          Are you sure you want to email result to <br /> {singleCheck.name}?
        </Modal>
        <h2 className="header inline">
          Check Information:
        <button onClick={this.handleRefresh} className="iconBtn">
          <img src={refresh} alt="refresh" />
        </button>
        </h2>
        {
          singleCheck.status === "request_success" &&
          <button className="Button primary inline" onClick={() => this.handleOpenModal(singleCheck)}>
            Email Result
          </button>
        }
        <div className="box">
          <Row>
            <Col xs={6}><b>Name:</b>{singleCheck.name}</Col>
            <Col xs={6}><b>Age:</b>{singleCheck.age}</Col>
            <Col xs={6}><b>Mobile:</b>{singleCheck.mobile}</Col>
            <Col xs={6}><b>Email:</b>{singleCheck.email}</Col>
          </Row>
          <Row>
            <Col xs={12}><b>MyKad</b></Col>
            <Col xs={12}><b>NRIC:</b> <Identity type={1} identity={`${singleCheck.nric}`} /></Col>
            {
              singleCheck && uploadedICFront ?
              <Image
                inline
                src={uploadedICFront ? uploadedICFront.body : null}
                alt="IC Front"
                loading={this.state.loadingImages}
                fullWidth
               />
               : 'No Upload IC Front'
             }
            {
              singleCheck && uploadedICBack ?
              <Image
                inline
                src={uploadedICBack ? uploadedICBack.body : null}
                alt="IC Back"
                loading={this.state.loadingImages}
                fullWidth
                />
              : 'No Upload IC Back'
            }
          </Row>
          <Row>
            <Col xs={12}><b>Status</b></Col>
            <Col xs={6}><b>Completed At:</b><Date time>{singleCheck.completedAt}</Date></Col>
            <Col xs={6}><b>Created At:</b><Date time>{singleCheck.createdAt}</Date></Col>
            <Col xs={3}><b>CCRIS Status:</b><Status>{singleCheck.status}</Status></Col>
          </Row>
          <Row>
          <Col xs={12}><b>IDs</b></Col>
            <Col xs={12}>
              <b>Check ID:</b><code>{singleCheck.checkID}</code><br />
              <b>Profile ID:</b><code>{singleCheck.profileID}</code><br />
              <b>User ID:</b><code>{singleCheck.userID}</code><br />
            </Col>
          </Row>  
          <Row>
            <Col xs={6}>
              <p><b>DSR Percent:</b> <Value percent>{singleCheck.dsrPercent}</Value></p>
            </Col>
            <Col xs={6}>
              <p><b>Income:</b> <Value money>{singleCheck.incomeNetCents}</Value></p>
            </Col>
            <Col xs={12}>
              <p><b>Credit Card Loan Amount:</b> <Value money>{singleCheck.creditCardLoanAmount}</Value></p>
              <p><b>Home Loan Amount:</b> <Value money>{singleCheck.homeLoanAmount}</Value></p>
              <p><b>Overdraft Loan Amount:</b> <Value money>{singleCheck.overdraftLoanAmount}</Value></p>
              <p><b>Personal Loan Amount:</b> <Value money>{singleCheck.personalLoanAmount}</Value></p>
              <p><b>Total Commitment Cents:</b> <Value money>{singleCheck.totalCommitmentCents}</Value></p>
            </Col>
            <Col xs={12}>
              <p><b>Loan Amount:</b> {singleCheck.loanCentsEligibleRange && <Value money>{singleCheck.loanCentsEligibleRange[0].loanAmount}</Value>}</p>
              <p><b>Eligible Max Loan Amount:</b> {singleCheck.loanCentsEligibleRange && <Value money>{singleCheck.loanCentsEligibleRange[0].maxLoanAmount}</Value>}</p>
              <p><b>Eligible Min Loan Amount:</b> {singleCheck.loanCentsEligibleRange && <Value money>{singleCheck.loanCentsEligibleRange[0].minLoanAmount}</Value>}</p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default connect(SingleCheck.mapStateToProps)(SingleCheck);



// WEBPACK FOOTER //
// ./src/containers/SingleCheck.jsx